import Button from '@eduzz/houston-ui/Button';
import React from 'react';
import { sendEventToGA } from 'v2/helpers/analytics';
import { financialStatementBlockedService } from 'v2/services/financialStatement/blocked';
import { financialStatementService } from 'v2/services/financialStatement/statement';

import { useStyles } from '../styles';

import type IPagination from 'interfaces/IPagination';

type Props = {
  isLoading?: boolean;
  pagination: IPagination;
  showBlockedDetails: boolean;
};

function PaginationLoadMore({ isLoading = false, pagination, showBlockedDetails }: Props) {
  const classes = useStyles();

  const loadMore = () => {
    sendEventToGA({
      category: 'Novo Extrato',
      action: 'Botão',
      label: 'Mostrar mais itens',
    });

    const newPagination = {
      ...pagination,
      current_page: pagination.current_page + 1,
    };

    showBlockedDetails
      ? financialStatementBlockedService.getNextPageDetails(newPagination)
      : financialStatementService.getNextPageDetails(newPagination);
  };

  const isLastPage = pagination?.current_page === pagination?.total_pages;

  if (isLastPage || isLoading) {
    return null;
  }

  return (
    <Button className={classes.btnMore} variant='outlined' onClick={loadMore}>
      Mostrar mais itens
    </Button>
  );
}

export default PaginationLoadMore;
